import { obtenerSesionContexto } from "../helpers/sesionesScope";

export type RoutePermission = {
  path: string;
  permiso?: string;
};

const HOME_ROUTE_CANDIDATES: RoutePermission[] = [
  { path: "/inicio" },
  { path: "/rendicion-caja", permiso: "modulos.rendicion_caja" },
  { path: "/conciliacion-caja", permiso: "modulos.conciliacion_caja" },
  { path: "/rrhh/importar-planilla", permiso: "rrhh.importar_planilla" },
  { path: "/rrhh/liquidacion-salario", permiso: "rrhh.liquidacion_salario" },
  { path: "/rrhh/reportes", permiso: "rrhh.reportes" },
  { path: "/rrhh/marcaciones", permiso: "rrhh.marcaciones" },
  { path: "/rrhh/consumision", permiso: "rrhh.consumision" },
  { path: "/ventas/pos", permiso: "ventas.pos" },
  { path: "/ventas/facturacion", permiso: "ventas.facturacion" },
  { path: "/ventas/notas-credito", permiso: "ventas.notas_credito" },
  { path: "/compras/ordenes", permiso: "compras.ordenes" },
  { path: "/compras/facturas", permiso: "compras.facturas" },
  { path: "/compras/notas-credito", permiso: "compras.notas_credito" },
  { path: "/contabilidad/asientos", permiso: "contabilidad.asientos" },
  { path: "/contabilidad/plan-cuentas", permiso: "contabilidad.plan_cuentas" },
  { path: "/contabilidad/articulos-cuentas", permiso: "contabilidad.articulos_cuentas" },
  { path: "/contabilidad/reportes", permiso: "contabilidad.reportes" },
  { path: "/produccion/recetas", permiso: "produccion.recetas" },
  { path: "/produccion/ordenes", permiso: "produccion.ordenes" },
  { path: "/informes/online/ventas", permiso: "informes.ventas_planilla" },
  { path: "/informes/online/compras", permiso: "informes.stock_compras" },
  { path: "/informes/online/inventarios", permiso: "informes.stock_inventarios" },
  { path: "/informes/online/transferencias", permiso: "informes.stock_transferencias" },
  { path: "/informes/online/finanzas", permiso: "informes.finanzas" },
  { path: "/informes/online/rrhh", permiso: "informes.rrhh" },
  { path: "/informes/online/tesoreria", permiso: "informes.tesoreria" },
  { path: "/informes/online/contabilidad", permiso: "informes.contabilidad" },
  { path: "/informes/online/logistica", permiso: "informes.logistica" },
  { path: "/informes/online/produccion", permiso: "informes.produccion" },
  { path: "/informes/online/gerencia", permiso: "informes.gerencia" },
  { path: "/informes/online/control-stock", permiso: "informes.stock_inventarios" },
  { path: "/informes/online/informatica", permiso: "informes.informatica" },
  { path: "/ajustes", permiso: "ajustes.acceder" },
];

const hasAccess = (permisos: string[], permiso?: string): boolean => {
  if (!permiso) {
    return true;
  }
  if (permisos.includes("general.solo_admin")) {
    return true;
  }
  return permisos.includes(permiso);
};

export const obtenerPrimerAccesoPermitido = (): string | null => {
  const contexto = obtenerSesionContexto();
  const permisos = contexto.permisos ?? [];
  const candidato = HOME_ROUTE_CANDIDATES.find((item) => hasAccess(permisos, item.permiso));
  return candidato?.path ?? null;
};
